import ArbitratorStaticComponent from "./ArbitratorStaticComponent";

export default ArbitratorStaticComponent;
